'use client'

import { motion } from 'framer-motion'
import Image from 'next/image'
import ImageWithFallback from 'src/components/ImageWithFallBack'

const TrustProofSection = () => {
  return (
    <section
      className="py-10 sm:py-16 bg-[#0a1734] text-white relative"
      data-item="trust-proof-section">
      <div className="container mx-auto px-4 md:px-8 ">
        <motion.div
          className="bg-white rounded-xl text-black max-w-5xl mx-auto overflow-hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}>
          <div className="flex flex-col">
            {/* Top Section */}
            <div className="flex flex-col lg:flex-row gap-4 p-4 sm:p-4 sm:pb-4 ">
              {/* Left Section */}
              <div className="w-full lg:w-3/5 border border-gray-200 rounded-lg py-8 sm:py-10 lg:py-12 px-6 sm:px-8 lg:px-10 gap-4 flex flex-col justify-between ">
                <h2 className="text-2xl sm:text-3xl lg:text-[2.5rem] font-bold mb-3 sm:mb-4 leading-6">
                  Trusted by 200+ Restaurant Brands
                </h2>
                <p className="text-gray-600 mb-2 text-sm sm:text-base lg:text-lg">
                  With 10,000+ locations managed and billions in third-party
                  sales tracked, Loop empowers operators to run profitable,
                  data-driven delivery businesses at scale — with clarity,
                  automation, and precision.
                </p>
              </div>

              {/* Right Section - Testimonial */}
              <div className="w-full lg:w-2/5 flex flex-col gap-4">
                <div className="bg-gradient-to-br from-[#FFF7E6] to-[#FFE5B2] rounded-lg p-4 sm:p-6">
                  <p className="text-gray-700 text-sm sm:text-[15px] leading-relaxed mb-4 sm:mb-6">
                    Loop enables us to identify customer trends, store downtime,
                    and marketing results — giving us real-time data to optimize
                    operations and maximize returns.
                  </p>

                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full overflow-hidden relative">
                      <Image
                        src="/case-study/carolinas/author.png"
                        alt="John Doe"
                        fill
                        className="object-cover"
                      />
                    </div>
                    <div>
                      <p className="font-medium text-xs sm:text-sm">
                        Zach James
                      </p>
                      <p className="text-gray-600 text-xs">
                        CFO, Subs of the Carolinas
                      </p>
                    </div>
                  </div>
                </div>

                {/* Data sync logos */}
                <div className="border border-gray-200 rounded-lg py-3 sm:py-4 px-3 sm:px-4">
                  <p className="text-base sm:text-lg font-medium mb-2">
                    Data sync
                  </p>
                  <div className="flex flex-wrap gap-3 sm:gap-6">
                    <Image
                      src="/images/logos/aws.svg"
                      alt="AWS"
                      width={50}
                      height={28}
                      className="object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                    />
                    <Image
                      src="/images/logos/gcp.svg"
                      alt="Google Cloud"
                      width={50}
                      height={28}
                      className="object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                    />
                    <Image
                      src="/images/logos/snowflake.svg"
                      alt="Snowflake"
                      width={50}
                      height={28}
                      className="object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                    />
                    <Image
                      src="/images/logos/azure.svg"
                      alt="Azure"
                      width={50}
                      height={28}
                      className="object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Section */}
            <div className="p-4 sm:p-4 pt-0 sm:pt-0">
              {/* Backed by logos */}
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-2 justify-start items-center border border-gray-200 rounded-lg p-4 sm:p-6">
                <div className="font-medium text-xl sm:text-2xl md:text-3xl text-center sm:text-left sm:ml-4 lg:ml-8">
                  Backed by the best
                </div>
                <div className="flex flex-wrap justify-center sm:justify-start gap-6 sm:gap-8 lg:gap-10 sm:ml-4 lg:ml-8">
                  <ImageWithFallback
                    src="/images/logos/ycomb.svg"
                    alt="Y Combinator"
                    width={50}
                    height={50}
                    className="object-contain"
                  />
                  <ImageWithFallback
                    src="/images/logos/datatech.svg"
                    alt="Data Tech"
                    width={50}
                    height={50}
                    className="object-contain"
                  />
                  <ImageWithFallback
                    src="/images/logos/ondeck.svg"
                    alt="On Deck"
                    width={120}
                    height={50}
                    className="object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default TrustProofSection
